module.exports = __webpack_public_path__ + "static/media/26UNRWA6.22a2a817.jpg";